export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7793.46288a1b.jpg";